import type { HydraGetSubscriptionItem } from '@/lib/services/Hydra/account/GET/getSubscriptions'

type Props = {
  subscription: HydraGetSubscriptionItem
}

export const getIsThereEnoughTimeForItemToShip = ({ subscription }: Props) => {
  if (!subscription.recurrence.dateNext) {
    return null
  }

  const shippingDate = new Date(subscription.recurrence.dateNext)
  const now = new Date()

  const timeDifference = shippingDate.getTime() - now.getTime()
  const hoursDifference = timeDifference / (1000 * 60 * 60)

  return hoursDifference >= 24
}
